import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/app/app';
import initIconLibrary from '@/icon-config';
import { Auth0Provider } from '@cmr/react-auth0';
import history from '@/history';
import reportWebVitals from './vitals';
import { registerServiceWorker } from '@cmr/react-ui-common';
import { ApiProvider } from '@cmr/react-api-hook';

initIconLibrary();

ReactDOM.render(
  <Auth0Provider
    client_id='Y1iy0QtpLy7jOYSGZWaTwE72Razximbx'
    autoLoginRedirect
    history={history}
  >
    <ApiProvider>
      <App />
    </ApiProvider>
  </Auth0Provider>,
  document.getElementById('root'),
);

registerServiceWorker();

reportWebVitals();
